export const CONTACT_PURCHASE_WARN_THRESHOLD = 1000;
export const LOCATION_INPUT_PLACEHOLDER = 'e.g. California, Los Angeles or 90001';
export const RADIUS_SEARCH_DEFAULT = 2;
export const FILTER_UPDATE_DEBOUNCE_DELAY = 250;
